import React from "react";
import { Form, Button, Select, Input, DatePicker, InputNumber } from "antd";
import "./Question.scss";
import { ReactSVG } from "react-svg";
import moment from "moment";
import DocumentsUploader from "../Upload/Documents";

const NotificationForm = ({
	handleSubmitForm,
	form,
	handleCancel,
	notificationId,
	setFile,
	file,
	screenState,
	setScreenState,
	stores,
	storeLoading,
	setType,
	type,
}) => {
	const onScreenChange = (value) => {
		form.setFieldsValue({ path_to_id: "" });
		if (
			[
				"category",
				"survey category",
				"products",
				"product",
				"review",
				"webview",
			].includes(value)
		) {
			setScreenState(value);
		} else {
			setScreenState();
		}
	};

	const onCancel = () => {
		setType("general");
		handleCancel();
	};

	const onTypeChange = (value) => {
		setType(value);
		form.setFieldsValue({
			send_at: null,
			start_time: null,
			end_time: null,
		});
	};

	return (
		<div className="admin-form-container form-container">
			<Form form={form} onFinish={handleSubmitForm} requiredMark={false}>
				<div className="form-header">
					<div className="title">
						{notificationId ? "Update" : "New"} Notification
					</div>
				</div>
				<div className="form-content-group">
					<Form.Item
						label="Title"
						name="title"
						rules={[{ required: true, message: "Required" }]}
					>
						<Input placeholder="Title" />
					</Form.Item>
					<Form.Item
						label="Target Group"
						name="target_group"
						rules={[{ required: true, message: "Required" }]}
					>
						<Select placeholder="Target Group">
							<Select.Option value="public">Public</Select.Option>
							<Select.Option value="registered">Registered</Select.Option>
							<Select.Option value="eu_member">EU Member</Select.Option>
						</Select>
					</Form.Item>
					<Form.Item
						label="Type"
						name="type"
						rules={[{ required: true, message: "Required" }]}
					>
						<Select placeholder="Type" onChange={onTypeChange} value={type}>
							<Select.Option value="general">General</Select.Option>
							<Select.Option value="store">Store</Select.Option>
						</Select>
					</Form.Item>
					{type === "store" ? (
						<>
							<Form.Item
								label="Stores"
								name="store_ids"
								rules={[{ required: true, message: "Required" }]}
							>
								<Select
									placeholder="Stores"
									loading={storeLoading}
									mode="multiple"
									showSearch
									optionFilterProp="children"
								>
									{stores?.map((store) => (
										<Select.Option key={store?.id} value={store?.id}>
											{store?.name}
										</Select.Option>
									))}
								</Select>
							</Form.Item>
							<Form.Item label="Start Time" name="start_time">
								<DatePicker
									format="YYYY-MM-DD HH:mm"
									showTime={{ defaultValue: moment("00:00:00", "HH:mm") }}
									style={{ width: "100%" }}
								/>
							</Form.Item>
							<Form.Item label="End Time" name="end_time">
								<DatePicker
									format="YYYY-MM-DD HH:mm"
									showTime={{ defaultValue: moment("00:00:00", "HH:mm") }}
									style={{ width: "100%" }}
								/>
							</Form.Item>
							<Form.Item label="Idle Time" name="idle_period">
								<InputNumber placeholder="Idle Time" />
							</Form.Item>
						</>
					) : (
						<Form.Item label="Send At" name="send_at">
							<DatePicker
								format="YYYY-MM-DD HH:mm"
								showTime={{ defaultValue: moment("00:00:00", "HH:mm") }}
								style={{ width: "100%" }}
							/>
						</Form.Item>
					)}
					<Form.Item
						label="Description"
						name="description"
						rules={[{ required: true, message: "Required" }]}
					>
						<Input.TextArea placeholder="Description" row={5} />
					</Form.Item>
					<Form.Item
						label="Image"
						name="file"
						className="notification-upload-image"
					>
						<DocumentsUploader
							name="file"
							documents={file}
							setDocuments={setFile}
							multiple={false}
							maxCount={1}
						/>
					</Form.Item>
					<div className="form-header">
						<div className="title">Path to</div>
					</div>
					<Form.Item
						label="Screen"
						name="screen"
						rules={[{ required: true, message: "Required" }]}
					>
						<Select placeholder="Screen" onChange={onScreenChange}>
							<Select.Option value="category">Category</Select.Option>
							<Select.Option value="products">Products</Select.Option>
							<Select.Option value="product">Product</Select.Option>
							<Select.Option value="orders history">
								Orders History
							</Select.Option>
							<Select.Option value="survey category">
								Survey Category
							</Select.Option>
							<Select.Option value="carts">Carts</Select.Option>
							<Select.Option value="surveys">Surveys</Select.Option>
							<Select.Option value="webview">Webview</Select.Option>
							{/* <Select.Option value="review">Review</Select.Option> */}
						</Select>
					</Form.Item>
					{screenState && (
						<Form.Item
							label={screenState === "webview" ? "Link" : "ID"}
							name="path_to_id"
							rules={[{ required: true, message: "Required" }]}
						>
							<Input
								placeholder={screenState === "webview" ? "https://" : "ID"}
							/>
						</Form.Item>
					)}
				</div>
				<div className="form-actions">
					<Button type="link" onClick={onCancel}>
						{" "}
						Cancel{" "}
					</Button>
					<Button type="primary" htmlType="submit" className="btn-primary">
						{notificationId ? "Update" : "Create"}
						<ReactSVG src="/icons/check-button.svg" />
					</Button>
				</div>
			</Form>
		</div>
	);
};

export default NotificationForm;
